(() => {
  const SELECTOR = '[data-ks-brands]';

  function initBrandsSection(section) {
    if (!section || section.dataset.ksBrandsReady === 'true') return;

    section.dataset.ksBrandsReady = 'true';

initSlider(section);
initBrandSearch(section);
initAlphabetHighlight(section);
initAlphabetNavigation(section);
initBackToTop(section);
  }

  function initSlider(section) {
    const slider = section.querySelector('[data-ks-brands-slider]');

    if (!slider) return;

    const viewport = slider.querySelector('[data-ks-brands-viewport]');
    const track = slider.querySelector('[data-ks-brands-track]');
    const previousButton = slider.querySelector('[data-ks-brands-previous]');
    const nextButton = slider.querySelector('[data-ks-brands-next]');
    const dotsContainer = section.querySelector('[data-ks-brands-dots]');
    const slides = Array.from(
      slider.querySelectorAll('[data-ks-brands-slide]')
    );

if (
  !viewport ||
  !track ||
  !previousButton ||
  !nextButton ||
  slides.length === 0
) {
  return;
}

    const loopEnabled = slider.dataset.loop === 'true';
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const autoplayDelay =
      Number(slider.dataset.autoplayDelay) || 5000;

    let currentPage = 0;
    let pageCount = 1;
    let slidesPerPage = 1;
    let autoplayTimer = null;
    let pointerStartX = null;
    let pointerCurrentX = null;
    let resizeTimer = null;

    
function getSlidesPerPage() {
  const viewportWidth = viewport.clientWidth;
  const slideWidth = slides[0].getBoundingClientRect().width;

  if (!viewportWidth || !slideWidth) {
    return 1;
  }

  return Math.max(
    1,
    Math.round(viewportWidth / slideWidth)
  );
}

function getPageCount() {
  return Math.max(
    1,
    Math.ceil(slides.length / slidesPerPage)
  );
}

function getPageOffset(page) {
  return page * viewport.clientWidth;
}

    function updateTrack(animate = true) {
      const offset = getPageOffset(currentPage);

      track.style.transition = animate
        ? 'transform 420ms cubic-bezier(0.22, 0.61, 0.36, 1)'
        : 'none';

      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    }

    function updateButtons() {
      const noNavigationNeeded = pageCount <= 1;

      previousButton.hidden = noNavigationNeeded;
      nextButton.hidden = noNavigationNeeded;

      if (dotsContainer) {
        dotsContainer.hidden = noNavigationNeeded;
      }

      if (noNavigationNeeded) return;

      if (loopEnabled) {
        previousButton.disabled = false;
        nextButton.disabled = false;
      } else {
        previousButton.disabled = currentPage === 0;
        nextButton.disabled = currentPage === pageCount - 1;
      }
    }

    function updateDots() {
      if (!dotsContainer) return;

      const dots = dotsContainer.querySelectorAll(
        '.ks-brands__slider-dot'
      );

      dots.forEach((dot, index) => {
        const isActive = index === currentPage;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute(
          'aria-current',
          isActive ? 'true' : 'false'
        );
      });
    }

    function buildDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'ks-brands__slider-dot';
        dot.setAttribute(
          'aria-label',
          `Markengruppe ${index + 1} anzeigen`
        );

        dot.addEventListener('click', () => {
          goToPage(index);
          restartAutoplay();
        });

        dotsContainer.appendChild(dot);
      }

      updateDots();
    }

    function normalisePage(page) {
      if (pageCount <= 1) return 0;

      if (loopEnabled) {
        return (page + pageCount) % pageCount;
      }

      return Math.max(0, Math.min(page, pageCount - 1));
    }

    function goToPage(page, animate = true) {
      currentPage = normalisePage(page);

      updateTrack(animate);
      updateButtons();
      updateDots();
    }

 function calculateSlider() {
  slidesPerPage = getSlidesPerPage();
  pageCount = getPageCount();
  currentPage = Math.min(currentPage, pageCount - 1);

  slider.classList.toggle('has-navigation', pageCount > 1);

  buildDots();
  goToPage(currentPage, false);
}

    function stopAutoplay() {
      if (!autoplayTimer) return;

      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();

      if (
        !autoplayEnabled ||
        pageCount <= 1 ||
        document.hidden ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      autoplayTimer = window.setInterval(() => {
        if (!loopEnabled && currentPage === pageCount - 1) {
          goToPage(0);
        } else {
          goToPage(currentPage + 1);
        }
      }, autoplayDelay);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    previousButton.addEventListener('click', () => {
      goToPage(currentPage - 1);
      restartAutoplay();
    });

    nextButton.addEventListener('click', () => {
      goToPage(currentPage + 1);
      restartAutoplay();
    });

 viewport.addEventListener('pointerdown', event => {
  pointerStartX = event.clientX;
  pointerCurrentX = event.clientX;

  stopAutoplay();
});

    viewport.addEventListener('pointermove', event => {
      if (pointerStartX === null) return;

      pointerCurrentX = event.clientX;
    });

    viewport.addEventListener('pointerup', () => {
      if (
        pointerStartX === null ||
        pointerCurrentX === null
      ) {
        return;
      }

      const distance = pointerCurrentX - pointerStartX;

      if (Math.abs(distance) >= 45) {
        goToPage(
          currentPage + (distance < 0 ? 1 : -1)
        );
      }

      pointerStartX = null;
      pointerCurrentX = null;

      startAutoplay();
    });

    viewport.addEventListener('pointercancel', () => {
      pointerStartX = null;
      pointerCurrentX = null;

      startAutoplay();
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => {
        calculateSlider();
      }, 120);
    });

    calculateSlider();
    startAutoplay();
  }

function initBrandSearch(section) {
  const searchWrapper = section.querySelector(
    '[data-ks-brands-search]'
  );
  const input = section.querySelector(
    '[data-ks-brands-search-input]'
  );
  const clearButton = section.querySelector(
    '[data-ks-brands-search-clear]'
  );
  const resultText = section.querySelector(
    '[data-ks-brands-search-result]'
  );
  const emptyMessage = section.querySelector(
    '[data-ks-brands-search-empty]'
  );

  const cards = Array.from(
    section.querySelectorAll('.ks-brands__card')
  );

  const letterSections = Array.from(
    section.querySelectorAll('[data-ks-brands-letter]')
  );

  const directory = section.querySelector(
  '.ks-brands__directory'
);

const search = section.querySelector(
  '.ks-brands__search'
);

const brandsList = section.querySelector(
  '.ks-brands__list'
);

const resultsPlaceholder = document.createComment(
  'KS Markenliste ursprüngliche Position'
);

if (brandsList) {
  brandsList.parentNode.insertBefore(
    resultsPlaceholder,
    brandsList
  );
}

  if (!searchWrapper || !input || cards.length === 0) {
    return;
  }

  function normalizeText(value) {
    return String(value || '')
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .trim();
  }

  function updateSearch() {
    const query = normalizeText(input.value);
    let visibleCount = 0;

    cards.forEach(card => {
      const brandName =
        card.dataset.ksBrandName ||
        card.textContent ||
        '';

      const isVisible =
        query === '' ||
        normalizeText(brandName).includes(query);

      card.hidden = !isVisible;
      card.classList.toggle(
        'is-search-hidden',
        !isVisible
      );

      if (isVisible) {
        visibleCount += 1;
      }
    });

    letterSections.forEach(letterSection => {
      const visibleCards = letterSection.querySelectorAll(
        '.ks-brands__card:not([hidden])'
      );

      letterSection.hidden =
        query !== '' && visibleCards.length === 0;
    });

    if (clearButton) {
      clearButton.hidden = query === '';
    }

    if (emptyMessage) {
      emptyMessage.hidden =
        query === '' || visibleCount > 0;
    }

    if (resultText) {
      if (query === '') {
        resultText.textContent = '';
      } else if (visibleCount === 1) {
        resultText.textContent = '1 passende Marke gefunden';
      } else {
        resultText.textContent =
          `${visibleCount} passende Marken gefunden`;
      }
    }

if (brandsList && directory) {
  if (query !== '') {
    search.parentNode.insertBefore(
      brandsList,
      search.nextSibling
    );

    if (emptyMessage) {
      directory.parentNode.insertBefore(
        emptyMessage,
        directory
      );
    }
  } else if (resultsPlaceholder.parentNode) {
    resultsPlaceholder.parentNode.insertBefore(
      brandsList,
      resultsPlaceholder.nextSibling
    );

    if (emptyMessage) {
      brandsList.parentNode.insertBefore(
        emptyMessage,
        brandsList.nextSibling
      );
    }
  }
}

if (directory) {
  directory.hidden = query !== '';
}

section.classList.toggle(
  'is-searching',
  query !== ''
);

}

  input.addEventListener('input', updateSearch);

  input.addEventListener('keydown', event => {
    if (event.key === 'Escape' && input.value !== '') {
      input.value = '';
      updateSearch();
      input.focus();
    }
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      input.value = '';
      updateSearch();
      input.focus();
    });
  }

  updateSearch();
}

function initAlphabetHighlight(section) {
  const links = Array.from(
    section.querySelectorAll(
      '.ks-brands__alphabet-item[href^="#"]'
    )
  );

  const letters = Array.from(
    section.querySelectorAll('[data-ks-brands-letter]')
  );

  const alphabet = section.querySelector(
    '.ks-brands__alphabet'
  );

  if (!links.length || !letters.length) return;

  let ticking = false;
  let currentActiveId = '';

  function updateActiveLetter() {
    const triggerPosition = 190;
    let activeLetter = letters[0];

    letters.forEach(letter => {
      if (letter.hidden) return;

      const rect = letter.getBoundingClientRect();

      if (rect.top <= triggerPosition) {
        activeLetter = letter;
      }
    });

    /*
      Am Seitenende den letzten sichtbaren Buchstaben aktivieren.
    */
    const nearPageBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 40;

    if (nearPageBottom) {
      const visibleLetters = letters.filter(
        letter => !letter.hidden
      );

      if (visibleLetters.length) {
        activeLetter =
          visibleLetters[visibleLetters.length - 1];
      }
    }

    const activeId = `#${activeLetter.id}`;

    if (activeId === currentActiveId) {
      ticking = false;
      return;
    }

    currentActiveId = activeId;

    links.forEach(link => {
      const isActive =
        link.getAttribute('href') === activeId;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');

        /*
          Nur die horizontale mobile Buchstabenleiste bewegen.
          Die Seite selbst wird dadurch nicht hoch- oder runtergescrollt.
        */
        if (
          alphabet &&
          alphabet.scrollWidth > alphabet.clientWidth
        ) {
          const targetLeft =
            link.offsetLeft -
            alphabet.clientWidth / 2 +
            link.offsetWidth / 2;

          alphabet.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        }
      } else {
        link.removeAttribute('aria-current');
      }
    });

    ticking = false;
  }

  function handleScroll() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateActiveLetter);
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  window.addEventListener('resize', handleScroll);

  updateActiveLetter();
}

function initAlphabetNavigation(section) {
  const links = section.querySelectorAll(
    '.ks-brands__alphabet-item[href^="#"]'
  );

  links.forEach(link => {
    link.addEventListener('click', event => {
      const targetId = link.getAttribute('href');

      if (!targetId) return;

      const target = section.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      links.forEach(item => {
        const isActive = item === link;

        item.classList.toggle('is-active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      target.scrollIntoView({
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth',
        block: 'start'
      });
    });
  });
}

  function initBackToTop(section) {
    const button = section.querySelector(
      '[data-ks-brands-back]'
    );

    if (!button) return;

    button.addEventListener('click', () => {
      section.scrollIntoView({
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth',
        block: 'start'
      });
    });
  }

  function initAllBrandsSections(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initBrandsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllBrandsSections();
    });
  } else {
    initAllBrandsSections();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      initAllBrandsSections(event.target);
    }
  );
})();